package app.smartcoding.realrate.localization

import androidx.compose.runtime.staticCompositionLocalOf

val strings: Map<String, Strings> = mapOf(
    EnStrings.code to EnStrings,
    ArStrings.code to ArStrings,
    BgStrings.code to BgStrings,
    BnStrings.code to BnStrings,
    DeStrings.code to DeStrings,
    EsStrings.code to EsStrings,
    FrStrings.code to FrStrings,
    HiStrings.code to HiStrings,
    IdStrings.code to IdStrings,
    ItStrings.code to ItStrings,
    JaStrings.code to JaStrings,
    KoStrings.code to KoStrings,
    MsStrings.code to MsStrings,
    NlStrings.code to NlStrings,
    PlStrings.code to PlStrings,
    PtStrings.code to PtStrings,
    RuStrings.code to RuStrings,
    ThStrings.code to ThStrings,
    TrStrings.code to TrStrings,
    UrStrings.code to UrStrings,
    ViStrings.code to ViStrings,
    ZhStrings.code to ZhStrings,
)

val LocalStrings = staticCompositionLocalOf { EnStrings }
